import { useKeenSlider } from 'keen-slider/react';

export const useCarousel = useKeenSlider<HTMLDivElement>;
